import { render, staticRenderFns } from "./ResetNewPasswordForm.vue?vue&type=template&id=32674444&"
import script from "./ResetNewPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ResetNewPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports